var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",class:_vm.behavior,style:(_vm.videoStyle),attrs:{"id":"video"}})}
var staticRenderFns = []

export { render, staticRenderFns }